// src/components/OwnerSidebar/OwnerSidebar.jsx

import React, { useEffect } from 'react';
import { LayoutDashboard, PencilLine, MessageCircleMore, LogOut, CalendarPlus, Image, Megaphone, Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchOwnerProfile } from '../../store/slices/ownerAuthSlice';
import './OwnerSidebar.css';

export default function OwnerSidebar() {
  const dispatch = useDispatch();
  const { owner, isAuthenticated } = useSelector((state) => state.ownerAuth);

  useEffect(() => {
    if (isAuthenticated && !owner) {
      dispatch(fetchOwnerProfile());
    }
  }, [dispatch, isAuthenticated, owner]);

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <Link to="/owner/dashboard" className="logo">
          <img src="/How2Play_mainLogo512.png" alt="How2Play Logo" />
        </Link>
      </div>  
      <nav>
        <ul>
          <li>
            <Link to="/owner/dashboard">
              <LayoutDashboard className="icon" />
              <span>대시보드</span>
            </Link>
          </li>
          <li>
            <Link to="/owner/edit">
              <PencilLine className="icon" />
              <span>클럽 정보 수정</span>
            </Link>
          </li>
          <li>
            <Link to="/owner/reviews">
              <MessageCircleMore className="icon" />
              <span>리뷰/문의</span>
            </Link>
          </li>
          <li>
            <Link to="/owner/events">
              <CalendarPlus className="icon" />
              <span>이벤트 관리</span>
            </Link>
          </li>
          
          {/* 슈퍼유저 전용 메뉴 */}
          {owner?.is_superuser && (
            <>
              <li className="divider">
                <span>관리자 전용</span>
              </li>
              <li>
                <Link to="/owner/clubs">
                  <Building2 className="icon" />
                  <span>클럽 관리</span>
                </Link>
              </li>
              <li>
                <Link to="/owner/banners">
                  <Image className="icon" />
                  <span>배너 관리</span>
                </Link>
              </li>
              <li>
                <Link to="/owner/announcements">
                  <Megaphone className="icon" />
                  <span>공지사항 관리</span>
                </Link>
              </li>
            </>
          )}
        </ul>
      </nav>

      <div className="logout">
        <button
          onClick={() => {
            localStorage.removeItem('ownerToken');
            window.location.href = '/owner';
          }}
        >
          <LogOut className="icon" />
          <span>로그아웃</span>
        </button>
      </div>
    </div>
  );
}



